// extracted by mini-css-extract-plugin
export default {"switchContainer":"pages-ESI-PatientSettingsPage-_style-module_switchContainer","text":"pages-ESI-PatientSettingsPage-_style-module_text"};